import { render, staticRenderFns } from "./BaseDropdownRouteSwitcher.vue?vue&type=template&id=432eeb1e&scoped=true"
import script from "./BaseDropdownRouteSwitcher.vue?vue&type=script&lang=js"
export * from "./BaseDropdownRouteSwitcher.vue?vue&type=script&lang=js"
import style0 from "./BaseDropdownRouteSwitcher.vue?vue&type=style&index=0&id=432eeb1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432eeb1e",
  null
  
)

export default component.exports